import { RouteItem } from '@eastcoal/router/types/route'

import {
  NOTICE_CREATE_PAGE_PATH,
  NOTICE_DETAIL_PAGE_PATH,
  NOTICE_EDIT_PAGE_PATH,
  NOTICE_LIST_PAGE_PATH
} from './constants/path'
import { NOTICE_LIST_PAGE_UUID } from './constants/uuid'

export const noticeRoute: RouteItem = {
  title: '网站公告',
  hideChildrenInMenu: true,
  uuid: NOTICE_LIST_PAGE_UUID,
  children: [
    {
      title: '网站公告列表',
      path: NOTICE_LIST_PAGE_PATH,
      Component: () => import('./List')
    },
    {
      title: '新增公告',
      path: NOTICE_CREATE_PAGE_PATH,
      Component: () => import('./Create')
    },
    {
      title: '编辑公告',
      path: NOTICE_EDIT_PAGE_PATH,
      Component: () => import('./Edit')
    },
    {
      title: '查看公告',
      path: NOTICE_DETAIL_PAGE_PATH,
      Component: () => import('./Detail')
    }
  ]
}
